"use strict";
exports.__esModule = true;
exports.Autocomplete = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var ExpandMore_1 = tslib_1.__importDefault(require("@material-ui/icons/ExpandMore"));
var lab_1 = require("@material-ui/lab");
var react_1 = tslib_1.__importStar(require("react"));
var Icon_1 = require("../Icon");
var TextField_1 = require("../TextField");
var styles_1 = require("./styles");
function DropdownPopper(props) {
    return (react_1["default"].createElement(core_1.Popper, tslib_1.__assign({}, props, { modifiers: {
            flip: { enabled: false },
            preventOverflow: { enabled: false }
        } })));
}
function Autocomplete(props) {
    var error = props.error, label = props.label, _a = props.multiple, multiple = _a === void 0 ? true : _a, _b = props.popupIcon, popupIcon = _b === void 0 ? react_1["default"].createElement(ExpandMore_1["default"], { color: "secondary" }) : _b, noOptionsText = props.noOptionsText, options = props.options, placeholder = props.placeholder, value = props.value, onChange = props.onChange, disableOpenOnFocus = props.disableOpenOnFocus, disabled = props.disabled, fullWidth = props.fullWidth, id = props.id, required = props.required, _c = props.variant, variant = _c === void 0 ? 'filled' : _c, _d = props.flipPopperEnabled, flipPopperEnabled = _d === void 0 ? false : _d, customBackgroundColor = props.customBackgroundColor, rest = tslib_1.__rest(props, ["error", "label", "multiple", "popupIcon", "noOptionsText", "options", "placeholder", "value", "onChange", "disableOpenOnFocus", "disabled", "fullWidth", "id", "required", "variant", "flipPopperEnabled", "customBackgroundColor"]);
    var clearIconOverwrite = styles_1.useAutocompleteStyles().clearIconOverwrite;
    var _e = react_1.useState(false), open = _e[0], setOpen = _e[1];
    var _f = react_1.useState(''), inputValue = _f[0], setInputValue = _f[1];
    react_1.useEffect(function () {
        if (!disableOpenOnFocus)
            setOpen(true);
    }, [disableOpenOnFocus]);
    var handleOnChange = function (event, newValue) {
        onChange && onChange(event, newValue);
    };
    var handleOpen = function () {
        if (inputValue.length > 0) {
            setOpen(true);
        }
    };
    var handleInputChange = function (_event, newInputValue) {
        setInputValue(newInputValue);
        if (newInputValue.length > 0) {
            setOpen(true);
        }
        else {
            setOpen(false);
        }
    };
    return (react_1["default"].createElement(lab_1.Autocomplete, tslib_1.__assign({ ChipProps: {
            deleteIcon: react_1["default"].createElement(Icon_1.Icon, { name: "close" })
        }, PopperComponent: flipPopperEnabled ? core_1.Popper : DropdownPopper, className: clearIconOverwrite, disabled: disabled, fullWidth: fullWidth, inputValue: inputValue, multiple: multiple, noOptionsText: noOptionsText || undefined, onChange: handleOnChange, onClose: function () { return setOpen(false); }, onInputChange: handleInputChange, onOpen: disableOpenOnFocus ? handleOpen : undefined, open: disableOpenOnFocus ? open : undefined, options: options, popupIcon: popupIcon, renderInput: function (params) { return (react_1["default"].createElement(TextField_1.TextField, tslib_1.__assign({}, params, { customBackgroundColor: customBackgroundColor, error: error ? true : false, helperText: error, label: label + (required ? ' *' : ''), placeholder: placeholder, variant: variant }))); }, value: value }, rest)));
}
exports.Autocomplete = Autocomplete;
//# sourceMappingURL=Autocomplete.js.map